/**
 * Toggle (show/hide) functionality. Can be used for:
 * - Show/hide text
 * - Show/hide site elements (eg. extra information, toggle menu etc).
 * - Specific function for check if there's a search description text
 */
 ready().then(function() {

    window.toggleText = () => {
        /**
         * Collapse text and back
         */

        $('.toggle-text-container').on('click',function () {
            $(this).closest('.toggle-text-parent').toggleClass('has-full-height'); // give the parent the full height it needs

            if($(this).find('.toggle-text').text() == 'Lees meer') { // and change the default text
                $(this).find('.toggle-text').text('Lees minder');
            } else {
                $(this).find('.toggle-text').text('Lees meer');
            }
        });

        /**
         * SEO-block on Book Archive Pages specific
         * check if there is text in the seo-content block when clicked on a filter in the sidebar
         */
        const checkForSearchDescTextExistence = () => {
            $(document).ajaxComplete(function() {
                const searchintro = $('.archive .search-intro.toggle-text-parent');
                const searchdesc = searchintro.find('.description');

                if(searchdesc.length == 0) {
                    searchintro.addClass('has-no-text');
                }

            });
        }
        checkForSearchDescTextExistence();

    }

    toggleText();
});
